"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivisionService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class DivisionService {
    /**
     * @param id
     * @returns DivisionType The divisions for logged in user, as comma separated ids
     * @throws ApiError
     */
    static getDivisions(id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/divisions',
            query: {
                'id': id,
            },
            errors: {
                403: `Unauthorized`,
            },
        });
    }
}
exports.DivisionService = DivisionService;
